__turbopack_context__.v({
  "header": "HeaderMenu-module__BvJW-q__header",
  "headerInternalContainer": "HeaderMenu-module__BvJW-q__headerInternalContainer",
  "inner": "HeaderMenu-module__BvJW-q__inner",
  "link": "HeaderMenu-module__BvJW-q__link",
  "linkLabel": "HeaderMenu-module__BvJW-q__linkLabel",
  "mobileMenu": "HeaderMenu-module__BvJW-q__mobileMenu",
  "subLink": "HeaderMenu-module__BvJW-q__subLink",
});
